import { Link } from 'react-router-dom';
import { categories, posts } from '@/mocks/posts';

const toneMap: Record<string, { wrap: string; icon: string }> = {
  primary: { wrap: 'bg-primary-50 border-primary-200', icon: 'bg-primary-500 text-background-50' },
  accent: { wrap: 'bg-accent-50 border-accent-200', icon: 'bg-accent-500 text-background-50' },
  secondary: { wrap: 'bg-secondary-50 border-secondary-200', icon: 'bg-secondary-500 text-background-50' },
  foreground: { wrap: 'bg-background-100 border-background-300', icon: 'bg-foreground-800 text-background-50' },
};

export default function CategoryStrip() {
  return (
    <section className="w-full px-4 py-10 md:px-8" aria-labelledby="categories-heading">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 id="categories-heading" className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            四条主线，一个都别落下
          </h2>
          <p className="mt-2 text-sm text-foreground-600">从明星到素人，从传闻到时间线，按栏目追更更省心。</p>
        </div>
        <Link
          to="/category/deep"
          className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          查看全部栏目
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {categories.map((category) => {
          const tone = toneMap[category.accent] ?? toneMap.primary;
          const count = posts.filter((p) => p.categorySlug === category.slug).length;
          return (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className={`group flex flex-col rounded-lg border p-5 transition-colors hover:border-primary-300 ${tone.wrap}`}
            >
              <span className={`mb-4 flex h-11 w-11 items-center justify-center rounded-md ${tone.icon}`}>
                <i className={`${category.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="font-heading text-lg font-semibold text-foreground-950">{category.label}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{category.desc}</p>
              <span className="mt-4 flex items-center justify-between text-xs font-medium text-foreground-700">
                <span>{count} 篇在榜</span>
                <i
                  className="ri-arrow-right-line transition-transform group-hover:translate-x-1"
                  aria-hidden="true"
                ></i>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}